import { css } from 'styled-components';
import { popoverBoxshadow, standardTransitionStyles } from 'design-system/src/sharedStyles';

export const popoverPanelStyles = css`
  box-sizing: border-box;
  z-index: 1000;
  background: var(--white);
  border-radius: 6px;
  border: 1px solid var(--border-gray);
  ${popoverBoxshadow}
  --anchor-gap: 0.5rem;

  ${standardTransitionStyles}

  &[data-closed] {
    opacity: 0;
  }
`;

export const popoverPanelFocusOverrides = css`
  &:focus-visible {
    outline: none;
    box-shadow: none;
  }
`;
